var _rect, _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDepositUsdt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4400_3241)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#0C8A63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 20,
    fill: "#0C8A63"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4400_3241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -4,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4400_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.132 17.8456V17.8424C17.9937 17.852 17.2799 17.8938 15.6915 17.8938C14.4214 17.8938 13.5307 17.8584 13.2156 17.8424V17.8456C8.33132 17.6302 4.68823 16.7813 4.68823 15.762C4.68823 14.7459 8.33454 13.8938 13.2156 13.6784V16.9999C13.5339 17.0224 14.4503 17.0771 15.714 17.0771C17.2316 17.0771 17.9905 17.0128 18.132 16.9999V13.6816C23.0066 13.9002 26.64 14.7491 26.64 15.7652C26.64 16.7813 23.0033 17.6301 18.132 17.8488V17.8456ZM18.132 13.3375V10.3665H24.9326V5.83594H6.41814V10.3665H13.2188V13.3375C7.69145 13.5916 3.53711 14.6848 3.53711 15.9967C3.53711 17.3086 7.69467 18.4019 13.2188 18.6591V28.1832H18.1352V18.6591C23.6529 18.4051 27.8008 17.3118 27.8008 15.9999C27.8008 14.6912 23.6529 13.5948 18.1352 13.3408",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4400_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDepositUsdt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DepositUsdt.3261ad08.svg";
export { ForwardRef as ReactComponent };